import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './shared/guards/auth.guard';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SentryErrorHandler } from './sentry-error-handler';
import { UiComponentsModule } from '@dash-nx/ui-components';
import { MyHttpInterceptor } from './shared/interceptors/http.interceptor';
import { UrlNotFoundComponent } from './shared/components/url-not-found/url-not-found.component';
import { Redirect } from './shared/guards/redirect.guard';
import { environment } from '../environments/environment';

function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    `./assets/i18n-26/${environment.appId}/`,
    '.json'
  );
}

@NgModule({
  declarations: [AppComponent, UrlNotFoundComponent],
  imports: [
    BrowserModule,
    TranslateModule.forRoot({
      extend: true,
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    UiComponentsModule,
  ],
  providers: [
    AuthGuard,
    TranslateService,
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: MyHttpInterceptor, multi: true },
    Redirect,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
